<template>
  <section>
    <div class="container fade-in" :class="{ loading: !isLoaded }">
      <div class="row align-items-center">
        <div class="col-5 d-none d-md-block">
          <div class="wrap">
            <h2>
              Get in touch with me
            </h2>
            <h3>
              To discuss partnerships and other work-related stuff 🙂
            </h3>
          </div>
        </div>
        <div class="col-12 col-md-7 top-position">
          <get-in-touch />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import GetInTouch from "@/components/get-in-touch/GetInTouch";
import isLoaded from "@/mixins/isLoaded";
export default {
  components: { GetInTouch },
  mixins: [isLoaded],
  data() {
    return {
      delay: 500
    };
  }
};
</script>

<style lang="scss" scoped>
section {
  background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    url("~@/assets/img/get-in-touch.jpg");

  .fade-in {
    opacity: 1;
    transition: opacity 1s ease;

    &.loading {
      opacity: 0;
    }
    h2 {
      margin-bottom: 0.7rem;
    }
    h3 {
      margin-top: 0.7rem;
    }
  }
  .top-position {
    z-index: 1;
  }
}
</style>
